<div class="col formscreen">
    <rr-start-logo color="inverse" routerLink="/"></rr-start-logo>
    <form class="loginform" [formGroup]="verifyForm" (ngSubmit)="onSubmit()">
        <div class="col headline">
            <h1>Verify</h1>
            <span
                >Verify yourself by entering your 2FA-Code we send to your
                <strong>E-Mail-Account</strong>.
            </span>
        </div>
        <div class="col withlink tiny">
            <rr-input
                label="2FA Code"
                type="text"
                id="2fa-code"
                name="2fa-code"
                [required]="true"
                formControlName="code"
            ></rr-input>
            <a href="/login">Log in again?</a>
        </div>
        <rr-btn type="Primary" (btnClick)="onSubmit()">Verify code</rr-btn>
        <div class="row gap-8 tiny">
            <span>Do you need a new 2FA-Code?</span>
            <span class="link" (click)="newCode()">New code</span>
        </div>
        <rr-divider></rr-divider>
        <span class="tiny"
            >By logging in you agree to our
            <a target="_blank" href="/terms">terms</a> and have read the
            <a target="_blank" href="/privacy">privacy policy</a>.</span
        >
    </form>
</div>
<div class="rightsideimage"></div>
<rr-spinner *ngIf="!hidespinner"></rr-spinner>
